export function capitalizeLowercaseString(uppercaseString) {
    // Convert the string to lowercase
    const lowercaseString = uppercaseString.toLowerCase();

    // Capitalize the first letter
    const capitalizedString = lowercaseString.charAt(0).toUpperCase() + lowercaseString.slice(1);

    return capitalizedString;
}
